import * as Geometry from '../geometry';
import * as GHMath from '../../math';

export default class OBase {
  constructor (src) {
    this.ghGeometryObject = null;
    this.inputs = {};
    this.outputs = {};

    if (src !== undefined) {
      // copy
      this.ghGeometryObject = src.ghGeometryObject;
      this.inputs = src.inputs;
      this.outputs = src.outputs;
    }
  }

  getGenericObjectOutput (name) {
    return this.outputs[name].paramObject;
  }

  hasInput (name) {
    return name in this.inputs;
  }

  getObjectInput (name) {
    let inputObject = this.inputs[name].paramObject;
    if (inputObject !== undefined && inputObject !== null) {
      return inputObject.value;
    }
    return null;
  }

  getStringInput (name) {
    let tree = new Geometry.DataTree();

    var input = this.inputs[name];

    let inputObj = input.paramObject;
    if (inputObj !== null) {
      let tempTree = inputObj.value;
      for (let i = 0; i < tempTree.branches.length; i++) {
        for (let j = 0; j < tempTree.branches[i].length; j++) {
          let val = tempTree.branches[i][j];
          let stringVal = this.convertObjectToString(val);
          tree.add(stringVal, tempTree.paths[i]);
        }
      }
    } else {
      tree.add(input.ghInputParam.defaultValue, new Geometry.GHPath(0));
    }

    return tree;
  }

  getFloatInput (name) {
    let tree = new Geometry.DataTree();

    let input = this.inputs[name];
    if (!(name in this.inputs)) return tree;
    var inputObj = input.paramObject;
    if (inputObj !== null) {
      var tempTree = inputObj.value;
      // console.log(tempTree)
      for (let i = 0; i < tempTree.branches.length; i++) {

        if(tempTree.branches[i].length == 0){
          let path = tempTree.paths[i];
          tree.addEmpty(path);
          continue;
        }

        for (let j = 0; j < tempTree.branches[i].length; j++) {
          let val = tempTree.branches[i][j];
          if (val instanceof THREE.Vector3) {
            val = val.length();
          } else if ((typeof val) === 'string') {
            switch (val) {
              case 'True':
              case 'true':
                val = 1;
                break;
              case 'False':
              case 'false':
                val = 0;
                break;
            }
          }
          tree.add(Number(val), tempTree.paths[i]);
        }
      }
    } else {
      tree.add(input.ghInputParam.defaultValue, new Geometry.GHPath(0));
    }

    return tree;
  }

  getVector3Input (inputName, flipZ = false) {
    let input = this.inputs[inputName].paramObject;
    let outVecTree = new Geometry.DataTree();

    if (input !== null) {
      let tempVec = input.value;
      for (let i = 0; i < tempVec.branches.length; i++) {
        outVecTree.addEmpty(tempVec.paths[i]);
        for (let j = 0; j < tempVec.branches[i].length; j++) {
          let val = tempVec.branches[i][j];
          let vector = this.convertObjectToVector3(val, flipZ);
          outVecTree.add(vector, tempVec.paths[i]);
        }
      }
      // console.log(this.constructor.name, input.value, outVecTree)
    } else {
      var defval = this.inputs[inputName].ghInputParam.defaultValue;
      var newVec = new THREE.Vector3(defval.x, defval.y, defval.z);
      if (flipZ) {
        let prev = newVec.clone();
        newVec = new THREE.Vector3(prev.x, prev.z, prev.y);
      }
      outVecTree.add(newVec, new Geometry.GHPath(0));
    }

    return outVecTree;
  }

  getFloatOrVectorInput (name) {
    let tree = new Geometry.DataTree();

    var input = this.inputs[name];

    var inputObj = input.paramObject;
    if (inputObj !== null) {
      var tempTree = inputObj.value;
      for (let i = 0; i < tempTree.branches.length; i++) {

        if(tempTree.branches[i].length == 0){
          let path = tempTree.paths[i];
          tree.addEmpty(path);
          continue;
        }

        for (let j = 0; j < tempTree.branches[i].length; j++) {
          var val = tempTree.branches[i][j];

          var cValue = this.convertObjectToFloatOrVector3(val);
          tree.add(cValue, tempTree.paths[i]);
        }
      }
    } else {
      tree.add(input.ghInputParam.defaultValue, new Geometry.GHPath(0));
    }

    return tree;
  }

  getBoolInput (name) {
    let tree = new Geometry.DataTree();

    var input = this.inputs[name];

    var inputObj = input.paramObject;
    if (inputObj !== null) {
      var tempTree = inputObj.value;
      for (let i = 0; i < tempTree.branches.length; i++) {
        for (let j = 0; j < tempTree.branches[i].length; j++) {
          let val = tempTree.branches[i][j];
          if (typeof val === 'string' && val === 'True') {
            val = 'true';
          } else if (typeof val === 'string' && val === 'False') {
            val = 'false';
          }
          let boolValue = this.convertObjectToBool(val);
          tree.add(boolValue, tempTree.paths[i]);
        }
      }
    } else {
      tree.add(input.ghInputParam.defaultValue, new Geometry.GHPath(0));
    }

    return tree;
  }

  getIntervalObjectInput (inputName) {
    let tree = new Geometry.DataTree();

    let input = this.inputs[inputName];

    let inputObj = input.paramObject;
    if (inputObj !== null && inputObj.value !== undefined) {
      var dataTree = inputObj.value;

      for (let i = 0; i < dataTree.branches.length; i++) {
        var path = dataTree.paths[i];
        for (let j = 0; j < dataTree.branches[i].length; j++) {
          var val = dataTree.branches[i][j];
          var intervalVal = this.convertObjectToInterval(val);
          tree.add(intervalVal, path);
        }
      }
    } else {
      tree.add(input.ghInputParam.defaultValue, new Geometry.GHPath(0));
    }

    return tree;
  }

  getCurveObjectInput (inputName) {
    var input = this.inputs[inputName].paramObject;
    if (input !== null) {
      return input.value;
    }
    return new Geometry.DataTree();
  }

  getSurfaceObjectInput (inputName) {
    var input = this.inputs[inputName].paramObject;
    if (input !== null) {
      return input.value;
    }
    return new Geometry.DataTree();
  }

  getSolidObjectInput (inputName) {
    let input = this.inputs[inputName].paramObject;
    if (input !== null) {
      return input.value;
    }
    return null;
  }

  convertObjectToString (val) {
    // console.log(val)
    return val.toString();
  }

  convertObjectToFloatOrVector3 (val) {
    // let objVal = null
    // console.log(val)
    return val;
  }

  convertObjectToVector3 (val, flipZ = false) {
    let v3Val = new THREE.Vector3();

    if (val instanceof THREE.Vector2) {
      if (flipZ) {
        v3Val = new THREE.Vector3(val.x, 0, val.y);
      } else {
        v3Val = new THREE.Vector3(val.x, val.y, 0);
      }
    } else if (val instanceof THREE.Vector3) {
      v3Val = val.clone();
      if (flipZ) {
        v3Val.y = val.z;
        v3Val.z = val.y;
      }
    } else if (val instanceof GHMath.GHPlane) {
      /*
      var plane = val
      let newVec = new THREE.Vector3(plane.center.x, plane.center.y, plane.center.z)
      if (flipZ) {
        newVec = new THREE.Vector3(plane.center.x, plane.center.z, plane.center.y)
      }
      v3Val = newVec
      */
      v3Val = val.normal.clone();
    }

    return v3Val;
  }

  convertObjectToInterval (val) {
    let intervalValue = null;
    if (val instanceof Geometry.Interval) {
      intervalValue = val;
    } else {
      let nval = Number(val);
      let min = Math.min(0, nval);
      let max = Math.max(0, nval);
      intervalValue = new Geometry.Interval(min, max);
    }
    return intervalValue;
  }

  convertObjectToPlane (val, flipZ = false) {
    let planeVal = null;

    if (val instanceof THREE.Vector3) {
      let vec3 = val;
      let plane = GHMath.constructPlane();
      if (flipZ) {
        vec3 = new THREE.Vector3(vec3.x, vec3.z, vec3.y);
        plane.flipZ();
      }
      plane.translate(vec3);
      planeVal = plane;
    } else if (val instanceof GHMath.GHPlane) {
      let plane = val;
      let newPlane = GHMath.constructPlane(plane.center, plane.xAxis, plane.yAxis);
      if (flipZ) {
        newPlane.flipZ();
      }
      planeVal = newPlane;
    }

    return planeVal;
  }

  convertObjectToBool (val) {
    return val;
  }

  getPlaneInput (inputName, flipZ = false) {
    let input = this.inputs[inputName].paramObject;
    var outPlaneTree = new Geometry.DataTree();

    if (input !== null) {
      var tempVec = input.value;
      for (let i = 0; i < tempVec.branches.length; i++) {
        for (let j = 0; j < tempVec.branches[i].length; j++) {
          let val = tempVec.branches[i][j];
          let planeVal = this.convertObjectToPlane(val, flipZ);
          outPlaneTree.add(planeVal, tempVec.paths[i]);
        }
      }
    } else {
      let defval = this.inputs[inputName].ghInputParam.defaultValue;
      let newPlane = GHMath.constructPlane(defval.center, defval.xAxis, defval.yAxis, 'getPlaneInput');
      if (flipZ) {
        newPlane.flipZ();
      }
      outPlaneTree.add(newPlane, new Geometry.GHPath(0));
    }

    return outPlaneTree;
  }

  graft (inputTree) {
    let graftTree = new Geometry.DataTree();

    for (let i = 0; i < inputTree.branches.length; i++) {

      if(inputTree.branches[i].length == 0){
        let path = new Geometry.GHPath(inputTree.paths[i]);
        path.add(0);
        graftTree.addEmpty(path);
        continue;
      }

      for (let j = 0; j < inputTree.branches[i].length; j++) {
        let path = new Geometry.GHPath(inputTree.paths[i]);
        path.add(j);

        let inputObj = inputTree.branches[i][j];

        graftTree.add(inputObj, path);
      }
    }

    return graftTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/OBase.js